/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { formatDateOnly, mapValues } from '../runtime';
import type { PriceStatus } from './PriceStatus';
import {
    PriceStatusFromJSON,
    PriceStatusFromJSONTyped,
    PriceStatusToJSON,
    PriceStatusToJSONTyped,
} from './PriceStatus';
import type { LaunchStatus } from './LaunchStatus';
import {
    LaunchStatusFromJSON,
    LaunchStatusFromJSONTyped,
    LaunchStatusToJSON,
    LaunchStatusToJSONTyped,
} from './LaunchStatus';
import type { LaunchStatusHy } from './LaunchStatusHy';
import {
    LaunchStatusHyFromJSON,
    LaunchStatusHyFromJSONTyped,
    LaunchStatusHyToJSON,
    LaunchStatusHyToJSONTyped,
} from './LaunchStatusHy';

/**
 * 
 * @export
 * @interface CreatePriceExperienceRowDto
 */
export interface CreatePriceExperienceRowDto {
    /**
     * 
     * @type {number}
     * @memberof CreatePriceExperienceRowDto
     */
    productId: number;
    /**
     * 
     * @type {number}
     * @memberof CreatePriceExperienceRowDto
     */
    priceUnitId: number;
    /**
     * 
     * @type {string}
     * @memberof CreatePriceExperienceRowDto
     */
    priceUnitName: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreatePriceExperienceRowDto
     */
    productName: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreatePriceExperienceRowDto
     */
    themeName: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreatePriceExperienceRowDto
     */
    productAudience?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreatePriceExperienceRowDto
     */
    localLaunchDate?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreatePriceExperienceRowDto
     */
    localExitDate?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreatePriceExperienceRowDto
     */
    productGroup: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreatePriceExperienceRowDto
     */
    groupName: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreatePriceExperienceRowDto
     */
    productCategory?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreatePriceExperienceRowDto
     */
    salesChannel?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreatePriceExperienceRowDto
     */
    license?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreatePriceExperienceRowDto
     */
    productClassLvl1?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreatePriceExperienceRowDto
     */
    productClassLvl2?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreatePriceExperienceRowDto
     */
    developmentOwnershipId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreatePriceExperienceRowDto
     */
    developmentOwnershipName?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreatePriceExperienceRowDto
     */
    productCompositionId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreatePriceExperienceRowDto
     */
    productCompositionName?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreatePriceExperienceRowDto
     */
    superSegmentId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreatePriceExperienceRowDto
     */
    superSegmentName?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreatePriceExperienceRowDto
     */
    themeCategoryId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreatePriceExperienceRowDto
     */
    readonly themeCategoryIdAsString?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreatePriceExperienceRowDto
     */
    themeCategoryName?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreatePriceExperienceRowDto
     */
    isRareItem?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CreatePriceExperienceRowDto
     */
    boxSizeId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreatePriceExperienceRowDto
     */
    boxSizeName?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof CreatePriceExperienceRowDto
     */
    businessToBusinessLaunchDate?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreatePriceExperienceRowDto
     */
    directToConsumerLifelong?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof CreatePriceExperienceRowDto
     */
    sizeDimension?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreatePriceExperienceRowDto
     */
    pieceCount?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreatePriceExperienceRowDto
     */
    smartPlayId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreatePriceExperienceRowDto
     */
    smartPlayName?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreatePriceExperienceRowDto
     */
    playTypeId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreatePriceExperienceRowDto
     */
    playTypeName?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreatePriceExperienceRowDto
     */
    topThemeId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreatePriceExperienceRowDto
     */
    topThemeName?: string | null;
    /**
     * 
     * @type {LaunchStatusHy}
     * @memberof CreatePriceExperienceRowDto
     */
    launchStatus?: LaunchStatusHy;
    /**
     * 
     * @type {LaunchStatus}
     * @memberof CreatePriceExperienceRowDto
     */
    productStatus?: LaunchStatus;
    /**
     * 
     * @type {PriceStatus}
     * @memberof CreatePriceExperienceRowDto
     */
    priceStatus?: PriceStatus;
    /**
     * 
     * @type {number}
     * @memberof CreatePriceExperienceRowDto
     */
    localLeadRrp: number;
    /**
     * 
     * @type {string}
     * @memberof CreatePriceExperienceRowDto
     */
    localLeadCurrency?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreatePriceExperienceRowDto
     */
    localLeadCurrencyDecimals: number;
    /**
     * 
     * @type {number}
     * @memberof CreatePriceExperienceRowDto
     */
    rrp: number;
    /**
     * 
     * @type {string}
     * @memberof CreatePriceExperienceRowDto
     */
    currency: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreatePriceExperienceRowDto
     */
    currencyDecimals: number;
    /**
     * 
     * @type {number}
     * @memberof CreatePriceExperienceRowDto
     */
    rrpIndexLocalLead: number;
    /**
     * 
     * @type {number}
     * @memberof CreatePriceExperienceRowDto
     */
    rrpIndexGlobalLead: number;
    /**
     * 
     * @type {number}
     * @memberof CreatePriceExperienceRowDto
     */
    vat?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreatePriceExperienceRowDto
     */
    rm: number;
    /**
     * 
     * @type {number}
     * @memberof CreatePriceExperienceRowDto
     */
    localLeadLp: number;
    /**
     * 
     * @type {number}
     * @memberof CreatePriceExperienceRowDto
     */
    lp: number;
    /**
     * 
     * @type {number}
     * @memberof CreatePriceExperienceRowDto
     */
    lpIndexLocalLead: number;
    /**
     * 
     * @type {number}
     * @memberof CreatePriceExperienceRowDto
     */
    lpIndexGlobalLead: number;
    /**
     * 
     * @type {number}
     * @memberof CreatePriceExperienceRowDto
     */
    listPriceFmcFactor: number;
    /**
     * 
     * @type {number}
     * @memberof CreatePriceExperienceRowDto
     */
    gcPercent: number;
    /**
     * 
     * @type {number}
     * @memberof CreatePriceExperienceRowDto
     */
    listPriceIncreaseCo: number;
    /**
     * 
     * @type {number}
     * @memberof CreatePriceExperienceRowDto
     */
    fmcLocal: number;
    /**
     * 
     * @type {number}
     * @memberof CreatePriceExperienceRowDto
     */
    forecastedDemand: number;
    /**
     * 
     * @type {string}
     * @memberof CreatePriceExperienceRowDto
     */
    primaryKey: string;
    /**
     * 
     * @type {number}
     * @memberof CreatePriceExperienceRowDto
     */
    themeId: number;
    /**
     * 
     * @type {string}
     * @memberof CreatePriceExperienceRowDto
     */
    readonly themeIdAsString: string;
    /**
     * 
     * @type {number}
     * @memberof CreatePriceExperienceRowDto
     */
    groupId: number;
    /**
     * 
     * @type {string}
     * @memberof CreatePriceExperienceRowDto
     */
    readonly groupIdAsString: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePriceExperienceRowDto
     */
    marketGroupName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreatePriceExperienceRowDto
     */
    subMarketGroupName?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreatePriceExperienceRowDto
     */
    useRrp: boolean;
    /**
     * 
     * @type {number}
     * @memberof CreatePriceExperienceRowDto
     */
    localLeadCurrencyRate: number;
    /**
     * 
     * @type {number}
     * @memberof CreatePriceExperienceRowDto
     */
    globalLeadCurrencyRate: number;
    /**
     * 
     * @type {number}
     * @memberof CreatePriceExperienceRowDto
     */
    localLeadRm: number;
    /**
     * 
     * @type {number}
     * @memberof CreatePriceExperienceRowDto
     */
    localLeadVat?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreatePriceExperienceRowDto
     */
    localLeadFunctionalDiscount: number;
    /**
     * 
     * @type {number}
     * @memberof CreatePriceExperienceRowDto
     */
    localLeadSalesDiscount: number;
    /**
     * 
     * @type {number}
     * @memberof CreatePriceExperienceRowDto
     */
    localLeadTradeContributionDiscount: number;
    /**
     * 
     * @type {string}
     * @memberof CreatePriceExperienceRowDto
     */
    globalLeadCurrency?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreatePriceExperienceRowDto
     */
    globalLeadCurrencyDecimals: number;
    /**
     * 
     * @type {number}
     * @memberof CreatePriceExperienceRowDto
     */
    globalLeadRrp: number;
    /**
     * 
     * @type {number}
     * @memberof CreatePriceExperienceRowDto
     */
    globalLeadLp: number;
    /**
     * 
     * @type {number}
     * @memberof CreatePriceExperienceRowDto
     */
    globalLeadRm: number;
    /**
     * 
     * @type {number}
     * @memberof CreatePriceExperienceRowDto
     */
    globalLeadVat?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreatePriceExperienceRowDto
     */
    globalLeadFunctionalDiscount: number;
    /**
     * 
     * @type {number}
     * @memberof CreatePriceExperienceRowDto
     */
    globalLeadSalesDiscount: number;
    /**
     * 
     * @type {number}
     * @memberof CreatePriceExperienceRowDto
     */
    globalLeadTradeContributionDiscount: number;
    /**
     * 
     * @type {number}
     * @memberof CreatePriceExperienceRowDto
     */
    functionalDiscount: number;
    /**
     * 
     * @type {number}
     * @memberof CreatePriceExperienceRowDto
     */
    salesDiscount: number;
    /**
     * 
     * @type {number}
     * @memberof CreatePriceExperienceRowDto
     */
    tradeContributionDiscount: number;
    /**
     * 
     * @type {number}
     * @memberof CreatePriceExperienceRowDto
     */
    fmcCostPerPiece: number;
    /**
     * 
     * @type {string}
     * @memberof CreatePriceExperienceRowDto
     */
    previousValidFrom?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreatePriceExperienceRowDto
     */
    previousRrp: number;
    /**
     * 
     * @type {number}
     * @memberof CreatePriceExperienceRowDto
     */
    previousLp: number;
    /**
     * 
     * @type {number}
     * @memberof CreatePriceExperienceRowDto
     */
    previousVat: number;
    /**
     * 
     * @type {number}
     * @memberof CreatePriceExperienceRowDto
     */
    nearestFutureModifiedLp?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreatePriceExperienceRowDto
     */
    nearestFutureModifiedLpValidFrom?: string | null;
}



/**
 * Check if a given object implements the CreatePriceExperienceRowDto interface.
 */
export function instanceOfCreatePriceExperienceRowDto(value: object): value is CreatePriceExperienceRowDto {
    if (!('productId' in value) || value['productId'] === undefined) return false;
    if (!('priceUnitId' in value) || value['priceUnitId'] === undefined) return false;
    if (!('priceUnitName' in value) || value['priceUnitName'] === undefined) return false;
    if (!('productName' in value) || value['productName'] === undefined) return false;
    if (!('themeName' in value) || value['themeName'] === undefined) return false;
    if (!('productGroup' in value) || value['productGroup'] === undefined) return false;
    if (!('groupName' in value) || value['groupName'] === undefined) return false;
    if (!('localLeadRrp' in value) || value['localLeadRrp'] === undefined) return false;
    if (!('localLeadCurrencyDecimals' in value) || value['localLeadCurrencyDecimals'] === undefined) return false;
    if (!('rrp' in value) || value['rrp'] === undefined) return false;
    if (!('currency' in value) || value['currency'] === undefined) return false;
    if (!('currencyDecimals' in value) || value['currencyDecimals'] === undefined) return false;
    if (!('rrpIndexLocalLead' in value) || value['rrpIndexLocalLead'] === undefined) return false;
    if (!('rrpIndexGlobalLead' in value) || value['rrpIndexGlobalLead'] === undefined) return false;
    if (!('rm' in value) || value['rm'] === undefined) return false;
    if (!('localLeadLp' in value) || value['localLeadLp'] === undefined) return false;
    if (!('lp' in value) || value['lp'] === undefined) return false;
    if (!('lpIndexLocalLead' in value) || value['lpIndexLocalLead'] === undefined) return false;
    if (!('lpIndexGlobalLead' in value) || value['lpIndexGlobalLead'] === undefined) return false;
    if (!('listPriceFmcFactor' in value) || value['listPriceFmcFactor'] === undefined) return false;
    if (!('gcPercent' in value) || value['gcPercent'] === undefined) return false;
    if (!('listPriceIncreaseCo' in value) || value['listPriceIncreaseCo'] === undefined) return false;
    if (!('fmcLocal' in value) || value['fmcLocal'] === undefined) return false;
    if (!('forecastedDemand' in value) || value['forecastedDemand'] === undefined) return false;
    if (!('primaryKey' in value) || value['primaryKey'] === undefined) return false;
    if (!('themeId' in value) || value['themeId'] === undefined) return false;
    if (!('themeIdAsString' in value) || value['themeIdAsString'] === undefined) return false;
    if (!('groupId' in value) || value['groupId'] === undefined) return false;
    if (!('groupIdAsString' in value) || value['groupIdAsString'] === undefined) return false;
    if (!('useRrp' in value) || value['useRrp'] === undefined) return false;
    if (!('localLeadCurrencyRate' in value) || value['localLeadCurrencyRate'] === undefined) return false;
    if (!('globalLeadCurrencyRate' in value) || value['globalLeadCurrencyRate'] === undefined) return false;
    if (!('localLeadRm' in value) || value['localLeadRm'] === undefined) return false;
    if (!('localLeadFunctionalDiscount' in value) || value['localLeadFunctionalDiscount'] === undefined) return false;
    if (!('localLeadSalesDiscount' in value) || value['localLeadSalesDiscount'] === undefined) return false;
    if (!('localLeadTradeContributionDiscount' in value) || value['localLeadTradeContributionDiscount'] === undefined) return false;
    if (!('globalLeadCurrencyDecimals' in value) || value['globalLeadCurrencyDecimals'] === undefined) return false;
    if (!('globalLeadRrp' in value) || value['globalLeadRrp'] === undefined) return false;
    if (!('globalLeadLp' in value) || value['globalLeadLp'] === undefined) return false;
    if (!('globalLeadRm' in value) || value['globalLeadRm'] === undefined) return false;
    if (!('globalLeadFunctionalDiscount' in value) || value['globalLeadFunctionalDiscount'] === undefined) return false;
    if (!('globalLeadSalesDiscount' in value) || value['globalLeadSalesDiscount'] === undefined) return false;
    if (!('globalLeadTradeContributionDiscount' in value) || value['globalLeadTradeContributionDiscount'] === undefined) return false;
    if (!('functionalDiscount' in value) || value['functionalDiscount'] === undefined) return false;
    if (!('salesDiscount' in value) || value['salesDiscount'] === undefined) return false;
    if (!('tradeContributionDiscount' in value) || value['tradeContributionDiscount'] === undefined) return false;
    if (!('fmcCostPerPiece' in value) || value['fmcCostPerPiece'] === undefined) return false;
    if (!('previousRrp' in value) || value['previousRrp'] === undefined) return false;
    if (!('previousLp' in value) || value['previousLp'] === undefined) return false;
    if (!('previousVat' in value) || value['previousVat'] === undefined) return false;
    return true;
}

export function CreatePriceExperienceRowDtoFromJSON(json: any): CreatePriceExperienceRowDto {
    return CreatePriceExperienceRowDtoFromJSONTyped(json, false);
}

export function CreatePriceExperienceRowDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePriceExperienceRowDto {
    if (json == null) {
        return json;
    }
    return {
        
        'productId': json['productId'],
        'priceUnitId': json['priceUnitId'],
        'priceUnitName': json['priceUnitName'],
        'productName': json['productName'],
        'themeName': json['themeName'],
        'productAudience': json['productAudience'] == null ? undefined : json['productAudience'],
        'localLaunchDate': json['localLaunchDate'] == null ? undefined : json['localLaunchDate'],
        'localExitDate': json['localExitDate'] == null ? undefined : json['localExitDate'],
        'productGroup': json['productGroup'],
        'groupName': json['groupName'],
        'productCategory': json['productCategory'] == null ? undefined : json['productCategory'],
        'salesChannel': json['salesChannel'] == null ? undefined : json['salesChannel'],
        'license': json['license'] == null ? undefined : json['license'],
        'productClassLvl1': json['productClassLvl1'] == null ? undefined : json['productClassLvl1'],
        'productClassLvl2': json['productClassLvl2'] == null ? undefined : json['productClassLvl2'],
        'developmentOwnershipId': json['developmentOwnershipId'] == null ? undefined : json['developmentOwnershipId'],
        'developmentOwnershipName': json['developmentOwnershipName'] == null ? undefined : json['developmentOwnershipName'],
        'productCompositionId': json['productCompositionId'] == null ? undefined : json['productCompositionId'],
        'productCompositionName': json['productCompositionName'] == null ? undefined : json['productCompositionName'],
        'superSegmentId': json['superSegmentId'] == null ? undefined : json['superSegmentId'],
        'superSegmentName': json['superSegmentName'] == null ? undefined : json['superSegmentName'],
        'themeCategoryId': json['themeCategoryId'] == null ? undefined : json['themeCategoryId'],
        'themeCategoryIdAsString': json['themeCategoryIdAsString'] == null ? undefined : json['themeCategoryIdAsString'],
        'themeCategoryName': json['themeCategoryName'] == null ? undefined : json['themeCategoryName'],
        'isRareItem': json['isRareItem'] == null ? undefined : json['isRareItem'],
        'boxSizeId': json['boxSizeId'] == null ? undefined : json['boxSizeId'],
        'boxSizeName': json['boxSizeName'] == null ? undefined : json['boxSizeName'],
        'businessToBusinessLaunchDate': json['businessToBusinessLaunchDate'] == null ? undefined : (new Date(json['businessToBusinessLaunchDate'])),
        'directToConsumerLifelong': json['directToConsumerLifelong'] == null ? undefined : json['directToConsumerLifelong'],
        'sizeDimension': json['sizeDimension'] == null ? undefined : json['sizeDimension'],
        'pieceCount': json['pieceCount'] == null ? undefined : json['pieceCount'],
        'smartPlayId': json['smartPlayId'] == null ? undefined : json['smartPlayId'],
        'smartPlayName': json['smartPlayName'] == null ? undefined : json['smartPlayName'],
        'playTypeId': json['playTypeId'] == null ? undefined : json['playTypeId'],
        'playTypeName': json['playTypeName'] == null ? undefined : json['playTypeName'],
        'topThemeId': json['topThemeId'] == null ? undefined : json['topThemeId'],
        'topThemeName': json['topThemeName'] == null ? undefined : json['topThemeName'],
        'launchStatus': json['launchStatus'] == null ? undefined : LaunchStatusHyFromJSON(json['launchStatus']),
        'productStatus': json['productStatus'] == null ? undefined : LaunchStatusFromJSON(json['productStatus']),
        'priceStatus': json['priceStatus'] == null ? undefined : PriceStatusFromJSON(json['priceStatus']),
        'localLeadRrp': json['localLeadRrp'],
        'localLeadCurrency': json['localLeadCurrency'] == null ? undefined : json['localLeadCurrency'],
        'localLeadCurrencyDecimals': json['localLeadCurrencyDecimals'],
        'rrp': json['rrp'],
        'currency': json['currency'],
        'currencyDecimals': json['currencyDecimals'],
        'rrpIndexLocalLead': json['rrpIndexLocalLead'],
        'rrpIndexGlobalLead': json['rrpIndexGlobalLead'],
        'vat': json['vat'] == null ? undefined : json['vat'],
        'rm': json['rm'],
        'localLeadLp': json['localLeadLp'],
        'lp': json['lp'],
        'lpIndexLocalLead': json['lpIndexLocalLead'],
        'lpIndexGlobalLead': json['lpIndexGlobalLead'],
        'listPriceFmcFactor': json['listPriceFmcFactor'],
        'gcPercent': json['gcPercent'],
        'listPriceIncreaseCo': json['listPriceIncreaseCo'],
        'fmcLocal': json['fmcLocal'],
        'forecastedDemand': json['forecastedDemand'],
        'primaryKey': json['primaryKey'],
        'themeId': json['themeId'],
        'themeIdAsString': json['themeIdAsString'],
        'groupId': json['groupId'],
        'groupIdAsString': json['groupIdAsString'],
        'marketGroupName': json['marketGroupName'] == null ? undefined : json['marketGroupName'],
        'subMarketGroupName': json['subMarketGroupName'] == null ? undefined : json['subMarketGroupName'],
        'useRrp': json['useRrp'],
        'localLeadCurrencyRate': json['localLeadCurrencyRate'],
        'globalLeadCurrencyRate': json['globalLeadCurrencyRate'],
        'localLeadRm': json['localLeadRm'],
        'localLeadVat': json['localLeadVat'] == null ? undefined : json['localLeadVat'],
        'localLeadFunctionalDiscount': json['localLeadFunctionalDiscount'],
        'localLeadSalesDiscount': json['localLeadSalesDiscount'],
        'localLeadTradeContributionDiscount': json['localLeadTradeContributionDiscount'],
        'globalLeadCurrency': json['globalLeadCurrency'] == null ? undefined : json['globalLeadCurrency'],
        'globalLeadCurrencyDecimals': json['globalLeadCurrencyDecimals'],
        'globalLeadRrp': json['globalLeadRrp'],
        'globalLeadLp': json['globalLeadLp'],
        'globalLeadRm': json['globalLeadRm'],
        'globalLeadVat': json['globalLeadVat'] == null ? undefined : json['globalLeadVat'],
        'globalLeadFunctionalDiscount': json['globalLeadFunctionalDiscount'],
        'globalLeadSalesDiscount': json['globalLeadSalesDiscount'],
        'globalLeadTradeContributionDiscount': json['globalLeadTradeContributionDiscount'],
        'functionalDiscount': json['functionalDiscount'],
        'salesDiscount': json['salesDiscount'],
        'tradeContributionDiscount': json['tradeContributionDiscount'],
        'fmcCostPerPiece': json['fmcCostPerPiece'],
        'previousValidFrom': json['previousValidFrom'] == null ? undefined : json['previousValidFrom'],
        'previousRrp': json['previousRrp'],
        'previousLp': json['previousLp'],
        'previousVat': json['previousVat'],
        'nearestFutureModifiedLp': json['nearestFutureModifiedLp'] == null ? undefined : json['nearestFutureModifiedLp'],
        'nearestFutureModifiedLpValidFrom': json['nearestFutureModifiedLpValidFrom'] == null ? undefined : json['nearestFutureModifiedLpValidFrom'],
    };
}

export function CreatePriceExperienceRowDtoToJSON(json: any): CreatePriceExperienceRowDto {
    return CreatePriceExperienceRowDtoToJSONTyped(json, false);
}

export function CreatePriceExperienceRowDtoToJSONTyped(value?: Omit<CreatePriceExperienceRowDto, 'themeCategoryIdAsString'|'themeIdAsString'|'groupIdAsString'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'productId': value['productId'],
        'priceUnitId': value['priceUnitId'],
        'priceUnitName': value['priceUnitName'],
        'productName': value['productName'],
        'themeName': value['themeName'],
        'productAudience': value['productAudience'],
        'localLaunchDate': value['localLaunchDate'],
        'localExitDate': value['localExitDate'],
        'productGroup': value['productGroup'],
        'groupName': value['groupName'],
        'productCategory': value['productCategory'],
        'salesChannel': value['salesChannel'],
        'license': value['license'],
        'productClassLvl1': value['productClassLvl1'],
        'productClassLvl2': value['productClassLvl2'],
        'developmentOwnershipId': value['developmentOwnershipId'],
        'developmentOwnershipName': value['developmentOwnershipName'],
        'productCompositionId': value['productCompositionId'],
        'productCompositionName': value['productCompositionName'],
        'superSegmentId': value['superSegmentId'],
        'superSegmentName': value['superSegmentName'],
        'themeCategoryId': value['themeCategoryId'],
        'themeCategoryName': value['themeCategoryName'],
        'isRareItem': value['isRareItem'],
        'boxSizeId': value['boxSizeId'],
        'boxSizeName': value['boxSizeName'],
        'businessToBusinessLaunchDate': value['businessToBusinessLaunchDate'] == null ? undefined : (formatDateOnly(value['businessToBusinessLaunchDate'] as any)),
        'directToConsumerLifelong': value['directToConsumerLifelong'],
        'sizeDimension': value['sizeDimension'],
        'pieceCount': value['pieceCount'],
        'smartPlayId': value['smartPlayId'],
        'smartPlayName': value['smartPlayName'],
        'playTypeId': value['playTypeId'],
        'playTypeName': value['playTypeName'],
        'topThemeId': value['topThemeId'],
        'topThemeName': value['topThemeName'],
        'launchStatus': LaunchStatusHyToJSON(value['launchStatus']),
        'productStatus': LaunchStatusToJSON(value['productStatus']),
        'priceStatus': PriceStatusToJSON(value['priceStatus']),
        'localLeadRrp': value['localLeadRrp'],
        'localLeadCurrency': value['localLeadCurrency'],
        'localLeadCurrencyDecimals': value['localLeadCurrencyDecimals'],
        'rrp': value['rrp'],
        'currency': value['currency'],
        'currencyDecimals': value['currencyDecimals'],
        'rrpIndexLocalLead': value['rrpIndexLocalLead'],
        'rrpIndexGlobalLead': value['rrpIndexGlobalLead'],
        'vat': value['vat'],
        'rm': value['rm'],
        'localLeadLp': value['localLeadLp'],
        'lp': value['lp'],
        'lpIndexLocalLead': value['lpIndexLocalLead'],
        'lpIndexGlobalLead': value['lpIndexGlobalLead'],
        'listPriceFmcFactor': value['listPriceFmcFactor'],
        'gcPercent': value['gcPercent'],
        'listPriceIncreaseCo': value['listPriceIncreaseCo'],
        'fmcLocal': value['fmcLocal'],
        'forecastedDemand': value['forecastedDemand'],
        'primaryKey': value['primaryKey'],
        'themeId': value['themeId'],
        'groupId': value['groupId'],
        'marketGroupName': value['marketGroupName'],
        'subMarketGroupName': value['subMarketGroupName'],
        'useRrp': value['useRrp'],
        'localLeadCurrencyRate': value['localLeadCurrencyRate'],
        'globalLeadCurrencyRate': value['globalLeadCurrencyRate'],
        'localLeadRm': value['localLeadRm'],
        'localLeadVat': value['localLeadVat'],
        'localLeadFunctionalDiscount': value['localLeadFunctionalDiscount'],
        'localLeadSalesDiscount': value['localLeadSalesDiscount'],
        'localLeadTradeContributionDiscount': value['localLeadTradeContributionDiscount'],
        'globalLeadCurrency': value['globalLeadCurrency'],
        'globalLeadCurrencyDecimals': value['globalLeadCurrencyDecimals'],
        'globalLeadRrp': value['globalLeadRrp'],
        'globalLeadLp': value['globalLeadLp'],
        'globalLeadRm': value['globalLeadRm'],
        'globalLeadVat': value['globalLeadVat'],
        'globalLeadFunctionalDiscount': value['globalLeadFunctionalDiscount'],
        'globalLeadSalesDiscount': value['globalLeadSalesDiscount'],
        'globalLeadTradeContributionDiscount': value['globalLeadTradeContributionDiscount'],
        'functionalDiscount': value['functionalDiscount'],
        'salesDiscount': value['salesDiscount'],
        'tradeContributionDiscount': value['tradeContributionDiscount'],
        'fmcCostPerPiece': value['fmcCostPerPiece'],
        'previousValidFrom': value['previousValidFrom'],
        'previousRrp': value['previousRrp'],
        'previousLp': value['previousLp'],
        'previousVat': value['previousVat'],
        'nearestFutureModifiedLp': value['nearestFutureModifiedLp'],
        'nearestFutureModifiedLpValidFrom': value['nearestFutureModifiedLpValidFrom'],
    };
}

